import React from 'react';
import {Navigation} from '../Navigation';
import * as RouterActions from '../../actions/RouterActions'
import {useDispatch} from 'react-redux';

export const StaticfilesNavigation = function(props){
    const dispatch = useDispatch();

    console.log(props);

    return (
        <Navigation title="Statische Dateien" icon="file alt" breadcrumb={props.breadcrumb} menu={
            [
                {
                    caption: 'Dateien',
                    icon: 'folder',
                    active: props.active === 'files',
                    onClick: () => dispatch(RouterActions.push('/staticfiles/files/'))
                },
                {
                    caption: 'Bereitstellen',
                    icon: 'share',
                    active: props.active === 'publish',
                    entries: [
                        {
                            caption: 'Mobile App',
                            icon: 'tablet',
                            onClick: () => dispatch(RouterActions.push('/staticfiles/publish/app')),
                            href: '/staticfiles/publish/app'
                        },
                        {
                            caption: 'OTT',
                            icon: 'tablet',
                            onClick: () => dispatch(RouterActions.push('/staticfiles/publish/kiosk')),
                            href: '/staticfiles/publish/kiosk'
                        }
                    ]
                }
            ]
        }>
            {props.children}
        </Navigation>
    )
}